import React from 'react';
import EditorString from '../Components/EditorString/EditorString';
import { EditorStringModel } from '../Types/EditorString';

interface UspItems {
  items: [
    {
      title: string;
      imageUrl: string;
      text: EditorStringModel;
    }
  ];
}

const UspBlock = ({ items }: UspItems) => {
  return (
    <div className="bg-gray-800">
      <ul className="container grid grid-cols-2 gap-4 text-white md:grid-cols-4">
        {items.map((item, index) => (
          <li
            className="flex flex-col items-center gap-4"
            key={item.title + index}
          >
            <img
              className="h-6 w-6"
              src={item.imageUrl}
              alt={item.title}
              loading="lazy"
            />
            <div className="flex flex-col items-center gap-2 text-center ">
              <h6 className="uppercase">{item.title}</h6>
              <EditorString value={item.text.value} className="text-md" />
            </div>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default UspBlock;
